import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-e2caaaf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center-screen bg-white w-full sm:w-1/3 border-b-4 border-amber-400 rounded-md flex justify-between items-center p-4 lg:px-10 md:space-x-8 flex-col md:flex-row space-y-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sm:w-max w-1/2",
  src: _imports_0,
  style: {"min-width":"100px"},
  alt: "avatar"
}, null, -1))
const _hoisted_3 = { class: "space-y-4 sm:w-2/3 w-full" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "text-md" }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = { class: "btn-simple flex flex-row space-x-2 items-center w-48" }
const _hoisted_8 = {
  key: 1,
  class: "right-screen bg-h-primary-100 border-b-4 border-r-4 fixed bottom-28 right-4 z-20 md:right-16 border-amber-400 rounded-t-2xl rounded-bl-2xl flex md:justify-between p-4 py-8 md:p-4 md:py-10 md:pr-10 flex-col sm:flex-row md:space-x-8"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 w-full sm:w-1/3 flex items-center justify-center sm:items-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "sm:w-max w-1/2",
    src: _imports_0,
    alt: "avatar"
  })
], -1))
const _hoisted_10 = { class: "space-y-4 sm:w-2/3 w-full" }
const _hoisted_11 = { class: "text-xl font-bold" }
const _hoisted_12 = { class: "text-md" }
const _hoisted_13 = { class: "flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_MessageVoice = _resolveComponent("MessageVoice")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.texts)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`fixed w-screen h-screen top-0 left-0 z-40 justify-center items-center ${
        _ctx.backgroundBlack ? 'flex' : 'hidden'
      }`),
          style: {"background-color":"rgba(0, 0, 0, 0.5)"}
        }, [
          (_ctx.texts[_ctx.actualText].position === 'center')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.texts[_ctx.actualText].title), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.texts[_ctx.actualText].text), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", _hoisted_7, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.audioON ? 'pi pi-volume-up' : 'pi pi-volume-off'),
                        style: {"font-size":"1rem"}
                      }, null, 2),
                      _createElementVNode("p", null, _toDisplayString(_ctx.audioON ? "Áudio ligado" : "Áudio desligado"), 1)
                    ]),
                    _createVNode(_component_Button, {
                      class: "btn-simple p-0 p-button-sm text-sm",
                      icon: "pi pi-replay",
                      label: "Repetir"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Button, {
                      class: "btn-primary w-full",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextText()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.texts[_ctx.actualText].answers[0].text), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.texts[_ctx.actualText].position === 'right')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.texts[_ctx.actualText].title), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.texts[_ctx.actualText].text), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_MessageVoice, {
                msg: _ctx.texts[_ctx.actualText].title + '.' + _ctx.texts[_ctx.actualText].text
              }, null, 8, ["msg"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "btn-primary w-full",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextText()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.texts[_ctx.actualText].answers[0].text), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}